import React from 'react';
import * as S from './style';
import { Label, Img } from 'components';
import { SERVICE_OFFER_STATUS } from 'commons/ZimssaConstant';

export interface Props {
    category: string;
    titles: Titles
}

type Titles = Array<{
        name: string;
        status: 'AVAILABLE' | 'NEGOTIABLE' | 'NOT_AVAILABLE';
        image: string;
}>;

function FeatureWrapper({ category, titles }: Props): React.ReactElement {
    const getServiceCountWithoutNotAvailable = (list: Titles): number => {
        return list.filter((item) => item.status !== SERVICE_OFFER_STATUS.NOT_AVAILABLE).length;
    };
    const serviceCount = getServiceCountWithoutNotAvailable(titles);

    return (
        <S.FeatureWrapper>
            <S.CategoryWrapper>
                {serviceCount > 0 ? 
                    <>
                        <Label fontStyle={'title'} color={'gray_opacity_800'} contents={category} />
                        <Label fontStyle={'title_bold'} color={'blue_900'} contents={getServiceCountWithoutNotAvailable(titles)} />
                    </> : null}
            </S.CategoryWrapper>
            {titles.map((item, index) => (
                (item.status !== SERVICE_OFFER_STATUS.NOT_AVAILABLE && 
                <S.TitleContainer key={index}>
                    {item.image ? (
                        <S.IconImageWrapper>
                            <Img src={item.image} alt={item.name} />
                        </S.IconImageWrapper>
                    ) : null}
                    <S.TitleWrapper isFirst={index === 0}>
                        <Label fontStyle={'body2'} color={'gray_opacity_800'} contents={item.name} />
                        {item.status === SERVICE_OFFER_STATUS.NEGOTIABLE ? (
                            <S.TagWrapper>
                                <Label fontStyle={'caption_bold'} color={'blue_900'} contents={'협의필요'} />
                            </S.TagWrapper>
                        ) : null}
                    </S.TitleWrapper>
                </S.TitleContainer>
            )))}
        </S.FeatureWrapper>
    );
}

export default FeatureWrapper;
